{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              31.943024661700804,
              29.978185767025565
            ],
            [
              36.771078037090035,
              18.484700136479177
            ],
            [
              38.876823648616636,
              14.488333700162073
            ],
            [
              43.389491616743584,
              9.30467287380013
            ],
            [
              55.84553202007797,
              15.544481672879328
            ],
            [
              62.50821665777684,
              23.157827481155977
            ],
            [
              56.11631078068086,
              26.52333135309283
            ],
            [
              47.565329476666136,
              32.55086900551878
            ],
            [
              31.943024661700804,
              29.978185767025565
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}